// Match Nette\Utils\Strings::truncate, including PCRE's Unicode whitespace boundaries.
const boundary = /[\u0000-/:-@\[-`{-~\u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]/;

export default function truncateText(value: string, length: number): string {
    const characters = Array.from(value);
    if (characters.length <= length) {
        return value;
    }

    const available = length - 1;
    for (let index = available; index > 0; index--) {
        if (boundary.test(characters[index])) {
            return characters.slice(0, index).join('') + '…';
        }
    }

    return characters.slice(0, available).join('') + '…';
}
